/*eslint-disable */
const API_ = CLIENT_API + '/api/v1';
const API_V2 = CLIENT_API + '/api/v2';

export const API_CLIENT = CLIENT_API + '/api/v1';
export const API_TECH = TECH_API + '/api/v1';

export let API_NB = null;

if (NB_API)
{
	API_NB = NB_API;
}

/*eslint-enable */

// AUTH
export const API_LOGIN          = API_ + '/auth/login/'
export const API_WHOAMI         = API_ + '/auth/me/'
export const API_UPDATE_ME      = API_ + '/auth/me/'
export const API_UPDATE_PROFILE = API_ + '/auth/me/profile/'
export const API_LOGOUT         = API_ + '/auth/logout/'

export let API_LOGIN_NB = null
export let API_CREATE_USER_NB = null

if (API_NB)
{
	API_LOGIN_NB = API_NB + 'auth/login/'
	API_CREATE_USER_NB = API_NB + 'ums/users/'
}

//JOB
export const API_GET_MY_JOB               = API_ + '/job/'

export const API_CREATE_JOB               = API_ + '/job/create/'
export const API_CREATE_JOB_LINK          = API_ + '/job/create/link/'
export const API_CREATE_JOB_LINK_FOR_PLAN = API_ + '/job/create/link/for/plan/'
export const API_JOB_UPLOAD_COMPLETE      = API_ + '/job/update/complete/'
export const API_LINKS_FOR_JOB            = (uuid) => `${API_}/job/links/for/${uuid}/`
export const API_LINKS_FOR_JOB_TECH       = (uuid) => `${API_V2}/job/links/for/${uuid}/`
export const API_LINKS_FOR_JOB_TECH2      = (uuid) => `${API_V2}/job/links/for/plan/${uuid}/`
export const API_LINKS_3D_PRECISE         = (uuid) => `${API_NB}tma/treatment/${uuid}/precise_plan_links/`

//STAFF
export const API_GET_JOB_FOR_TECH = API_ + '/staff/job/'
export const API_GET_MY_JOB_PAG           = `${API_V2}/staff/job/`
export const API_GET_MY_JOB_PAG2          = (date_from, date_to) => `${API_V2}/staff/job/?date_from=${date_from}&date_to=${date_to}`
export const API_GET_MY_JOB_TECH_PAG2          = (date_from, date_to) => `${API_V2}/staff/my_job/?date_from=${date_from}&date_to=${date_to}`
export const API_GET_JOB_FOR_TECH_UUID = (uuid) => `${API_}/staff/job/${uuid}/`
export const API_UPDATE_PLAN      = (uuid) => `${API_}/staff/job/plan/${uuid}/`
export const API_NEXT_STEP        = (uuid) => `${API_}/staff/job/run/next/step/${uuid}/`
export const API_FALLBACK       = (uuid) => `${API_}/staff/tam/fallback/${uuid}/`
export const API_GET_JOB_ASSETS   = (uuid, folder) => `${API_}/staff/job/plan/${uuid}/assets/${ folder || '' }`
export const API_SEND_COMMENT     = (uuid) => `${API_}/staff/job/plan/${uuid}/rework/`
export const API_DELETE_JOB       = (uuid) => `${API_}/staff/job/${uuid}/`
export const CHANGE_PRINTREADY_PARAMETERS = `${API_V2}/staff/job/change_printready_parameters/`

export const API_GET_TECHS       = (uuid) => `${API_V2}/staff/job/${uuid}/staff`
export const API_ASSIGN       = (uuid) => `${API_V2}/staff/job/${uuid}/assign`

//REFS
export const API_GET_PLAN_TYPE           = API_ + '/refs/plantype/'
export const API_GET_PLAN_CLOUD_PROVIDER = API_ + '/refs/plancloudprovider/'
export const API_GET_COMPANY             = API_ + '/refs/company/'

/* eslint-disable */
export const BASE_URL = _VIEWER_URL_ + '';



// WEBPACK FOOTER //
// ./src/config.js